import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const MoreIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 12.0003C5.5 11.1949 6.15292 10.542 6.95833 10.542C7.76375 10.542 8.41667 11.1949 8.41667 12.0003C8.41667 12.8057 7.76375 13.4587 6.95833 13.4587C6.15292 13.4587 5.5 12.8057 5.5 12.0003Z"
        fill="#555555"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5415 12.0003C10.5415 11.1949 11.1944 10.542 11.9998 10.542C12.8053 10.542 13.4582 11.1949 13.4582 12.0003C13.4582 12.8057 12.8053 13.4587 11.9998 13.4587C11.1944 13.4587 10.5415 12.8057 10.5415 12.0003Z"
        fill="#555555"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5835 12.0003C15.5835 11.1949 16.2364 10.542 17.0418 10.542C17.8472 10.542 18.5002 11.1949 18.5002 12.0003C18.5002 12.8057 17.8472 13.4587 17.0418 13.4587C16.2364 13.4587 15.5835 12.8057 15.5835 12.0003Z"
        fill="#555555"
      />
    </svg>
  );
};
